import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from "@angular/core";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

import { MenuTab, RoundFair } from "@models";
import { TranslatePipe } from "@pipes";
import { ActionService, GameService } from "@services";

import { ButtonComponent } from "../button/button.component";
import { CopyComponent } from "../copy/copy.component";
import { ModalInstance, ModalWithData } from "../modal/modal.interfaces";
import { ModalService } from "../modal/modal.service";
import { SvgComponent } from "../svg/svg.component";

interface Data {
  round_id: string;
}

@UntilDestroy()
@Component({
  templateUrl: "./bet-info-modal.component.html",
  styleUrls: ["./bet-info-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, SvgComponent, TranslatePipe, NgTemplateOutlet, CopyComponent],
})
export class BetInfoModalComponent implements ModalWithData<Data>, OnInit {
  private readonly mS = inject(ModalService);
  private readonly gS = inject(GameService);
  private readonly acS = inject(ActionService);

  public data: Data;
  public instance: ModalInstance<Data>;

  protected readonly lo = signal<boolean>(true);
  protected readonly rF = signal<RoundFair>({} as RoundFair);

  public ngOnInit(): void {
    this.gS
      .fair(this.data.round_id)
      .pipe(untilDestroyed(this))
      .subscribe(fair => {
        this.rF.set(fair);
        this.lo.set(false);
      });
  }

  public info(event: Event): void {
    this.acS.mS$.set({ tab: MenuTab.F_I });

    this.close(event);
  }

  public close(event: Event): void {
    event.stopPropagation();

    this.mS.close(this.instance);
  }
}
